/**
 * Display the lumber location details returned by the Lumber Part Lookup
 * query that is stored in dynamicInputResult field of the request
 * @param {Local.LumberPartLookupProps} props
 */
export const LumberPartLookup = ({ result }) => {
  if (!result?.item) return null;
  const { location } = result;
  return <span data-testid='dynamic-input-result'>{`Description: Location ${location}`}</span>;
};
